import React from 'react';

import { Route, BrowserRouter, Switch } from 'react-router-dom';
// import TTQH from "./containers/TTQH/index";
import HomaPage from './containers/TTQH/HomePage';

import Login from './containers/Login/Login';
import User from './containers/User';
import PrivateRoute from './components/PrivateRouter';
import Socket from './Socket';

// ql he thong
//User
import ManagerUser from './containers/QuanLyHeThong/QuanLyTaiKhoan';
import CreateUser from './containers/QuanLyHeThong/QuanLyTaiKhoan/CreateUser';
import EditUser from './containers/QuanLyHeThong/QuanLyTaiKhoan/EditUser';

// department
import ManagerDepartment from './containers/QuanLyHeThong/QuanLyPhongBan/DanhSachPhongBan';
import CreateDepartment from './containers/QuanLyHeThong/QuanLyPhongBan/CreateDepartment';

// log
import NhatKy from './containers/QuanLyHeThong/NhatKy';

import BieuDo from './containers/ThongKe/BieuDo';
import ThongKe500 from './containers/ThongKe/ThongKe500';
import ThongKe5000 from './containers/ThongKe/ThongKe5000';
import ThongKe10000 from './containers/ThongKe/ThongKe10000';

import QuyHoach500 from './containers/QuyHoachKienTruc/QuyHoach500';
import QuyHoach5000 from './containers/QuyHoachKienTruc/QuyHoach5000';
import QuyHoach100000 from './containers/QuyHoachKienTruc/QuyHoach10000';
import KienTruc from './containers/QuyHoachKienTruc/KienTruc';
import EditDepartment from './containers/QuanLyHeThong/QuanLyPhongBan/EditDepartment';

import { connect } from 'react-redux';
import ChinhSuaNhatKy from './containers/QuanLyHeThong/NhatKy/ChinhSuaNhatKy';

function BasicExample(permission) {
  let userPermission = permission.permission;

  let checkPermission = (arr) => {
    let check = false;
    arr.forEach((e) => {
      if (userPermission === e) {
        check = true;
        return check;
      }
    });
    return check;
  };

  return (
    <BrowserRouter>
      <Socket></Socket>
      <div>
        <Switch>
          <Route exact path='/' component={HomaPage}></Route>
          <Route path='/ttqh' component={HomaPage} />
          <Route path='/dang-nhap' component={Login} />
          <PrivateRoute path='/nguoi-dung' component={User} />

          {/* -----Ql he thong----- */}
          {checkPermission(['QuanTri']) && (
            <PrivateRoute exact path='/ql-nguoi-dung' component={ManagerUser} />
          )}

          {checkPermission(['QuanTri']) && (
            <PrivateRoute
              exact
              path='/ql-nguoi-dung/tao-moi'
              component={CreateUser}
            />
          )}

          {checkPermission(['QuanTri']) && (
            <PrivateRoute
              exact
              path='/ql-nguoi-dung/:id/chinh-sua'
              component={EditUser}
            />
          )}

          {checkPermission(['QuanTri']) && (
            <PrivateRoute exact path='/nhat-ky' component={NhatKy} />
          )}

          {checkPermission(['QuanTri']) && (
            <PrivateRoute
              exact
              path='/nhat-ky/:id/chinh-sua'
              component={ChinhSuaNhatKy}
            />
          )}

          {checkPermission(['QuanTri']) && (
            <PrivateRoute
              exact
              path='/ql-nhom-nguoi-dung'
              component={ManagerDepartment}
            />
          )}

          {checkPermission(['QuanTri']) && (
            <PrivateRoute
              exact
              path='/ql-nhom-nguoi-dung/tao-moi'
              component={CreateDepartment}
            />
          )}

          {checkPermission(['QuanTri']) && (
            <PrivateRoute
              exact
              path='/ql-nhom-nguoi-dung/:id/chinh-sua'
              component={EditDepartment}
            />
          )}

          {/* Ql quy hoach kien truc */}
          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien', 'Khac']) && (
            <PrivateRoute
              exact
              path='/ql-quy-hoach-chi-tiet'
              component={QuyHoach500}
            />
          )}

          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien', 'Khac']) && (
            <PrivateRoute
              exact
              path='/ql-quy-hoach-phan-khu'
              component={QuyHoach5000}
            />
          )}

          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien', 'Khac']) && (
            <PrivateRoute
              exact
              path='/ql-quy-hoach-chung'
              component={QuyHoach100000}
            />
          )}

          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien', 'Khac']) && (
            <PrivateRoute
              exact
              path='/ql-quy-hoach-kien-truc'
              component={KienTruc}
            />
          )}

          {/* Bieu do */}

          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien']) && (
            <PrivateRoute exact path='/thong-ke-tong-hop' component={BieuDo} />
          )}

          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien']) && (
            <PrivateRoute
              exact
              path='/thong-ke-quy-hoach-chi-tiet'
              component={ThongKe500}
            />
          )}

          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien']) && (
            <PrivateRoute
              exact
              path='/thong-ke-quy-hoach-phan-khu'
              component={ThongKe5000}
            />
          )}
          {checkPermission(['QuanTri', 'LanhDao', 'ChuyenVien']) && (
            <PrivateRoute
              exact
              path='/thong-ke-quy-hoach-chung'
              component={ThongKe10000}
            />
          )}
        </Switch>
      </div>
    </BrowserRouter>
  );
}

// export default BasicExample;

const mapStateToProps = (state) => {
  return {
    // isSocket: state.socket.isSocket,
    // isShowMapLayer: state.menu.isShowMapLayer,
    permission: state.auth.permission,
  };
};

const mapDispatchToProps = {
  // getAuthData: getDataAuth
};

export default connect(mapStateToProps, mapDispatchToProps)(BasicExample);
